import dayjs from 'dayjs';

import useStore from 'Hooks/useStore';
import { TicketsTabTrip } from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { useAvailability } from './useAvailability';
import { useIsLegVisuallyDisabled } from './useIsLegVisuallyDisabled';
import { useIsPaxSpaceExceeded } from './useIsPaxSpaceExceeded';
import { useIsSoldOut } from './useIsSoldOut';
import { useIsVehicleSpaceExceeded } from './useIsVehicleSpaceExceeded';
import { legClash } from './legClash';

export const useIsLegSelectable = (
	trip: TicketsTabTrip,
	wizardData: BookingWizardData,
	legType: 'departure' | 'return',
) => {
	const store = useStore();
	const isDisabled = useIsLegVisuallyDisabled(trip, wizardData);

	// The capacity half of `isDisabled`, needed on its own for departed sailings below.
	const availability = useAvailability(trip);
	const isSoldOut = useIsSoldOut(wizardData.tabSelected, availability.passenger, availability.vehicle);
	const exceedsPaxSpace = useIsPaxSpaceExceeded(trip.passengerSpacesAvailable, wizardData);
	const exceedsVehicleSpace = useIsVehicleSpaceExceeded(trip.vehicleSpacesAvailable, wizardData);
	const isFull = isSoldOut || exceedsPaxSpace || (wizardData.tabSelected === 'vehicle' && exceedsVehicleSpace);

	// No one can select a departure trip that is after the return trip, a return trip that is
	// before the departure trip, or the other leg's own trip.
	if (legClash(trip, wizardData, legType)) {
		return false;
	}

	// Full and closed legs are both choosable to whoever the server lets book them anyway.
	const canOverrideRestrictions = store.can('OverrideBookingRestrictions');
	const canOverbook = store.can('OverbookInBookingWizard');
	if (canOverbook && canOverrideRestrictions) return true;

	// A departed sailing is a restriction the server lifts for OverrideBookingRestrictions alone. This
	// was `isStaff`, so a staff member with it revoked could still pick one and be refused at reservation.
	// A *full* departed sailing is also an overbooking, and from the wizard that is
	// OverbookInBookingWizard whether the sailing has left or not - overbooking at the boat is check-in's.
	if (canOverrideRestrictions && dayjs(trip.departureDateTime).isBefore(dayjs()) && (!isFull || canOverbook)) {
		return true;
	}

	return !isDisabled;

	// if (wizardData.departureTicketId === ticketsTabTrip.id || wizardData.returningTicketId === ticketsTabTrip.id) {
	// 	return true;
	// }
	// if (isInvalidAlterationTicket) {
	// 	return false;
	// }
	// // Even though staff and managers have their trips that they are allowed to select, we need to ensure that they
	// // don't select a returning trip that leaves before the departing trip, as we don't want the wizard to allow
	// // this for anyone
	// if (!departure && wizardData.departureTicketId !== ''
	// 	&& ticketsTabTrip.startDate <= (departureTripTime ?? wizardData.ticketSelectionStartDate)) {
	// 	setIsValid(false);
	// 	return false;
	// }
	// // Staff can select any departed trip regardless of space capacity or departed status
	// if ((isStaff && disabledFerryTrip) || store.isManager) {
	// 	return true;
	// }
	// if (disabledFerryTrip && !isStaff) {
	// 	return false;
	// }
	// if (availabilityCss === 'no-availability' && !store.isManager) {
	// 	return false;
	// }
	// if (wizardData.tabSelected === 'vehicle' && (vehicleLengthExceeded || exceedsPassengerAvailable)) {
	// 	return false;
	// }
	// if (wizardData.tabSelected === 'passenger' && exceedsPassengerAvailable) {
	// 	return false;
	// }
	// return !isInvalidAlterationTicket;
};
